/*
 * @Author: zyb
 * @Date: 2022-03-22 19:05:10
 * @LastEditors: ldx
 * @LastEditTime: 2024-05-14 13:47:02
 * @FilePath: \dev_2.0\src\store\index.js
 * @Description:
 */
import Vue from "vue";
import Vuex from "vuex";
import util from "../utils/index";
import {
  findCategoryTree,
  getNewsByPage,
  listProductContent,
  getOfficialNewsCategory,
  getCaseOrTainByPage,
  getBannerList,
  listProductCategory,
} from "../network/newApi";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    productNacList: [], //产品中心tab列表
    currentProductTab: localStorage.getItem("nav") == 'undefined' ? {} : JSON.parse(localStorage.getItem("nav")), //选中的产品中心tab
    newsList: null, //新闻详情页底部的上一个信息和下一个信息
    caseTabList: null, //案例的分类tab
    prevInfo: {},
  },
  mutations: {
    SAVE_PRODUCT_NAV_LIST(state, arr) {
      state.productNacList = arr;
    },
    SAVE_PRODUCT_CURRENT_TAB(state, nav) {
      state.currentProductTab = nav;
    },
    SAVE_NEWS_LIST(state, arr) {
      state.newsList = arr;
    },
    SAVE_CASE_LIST(state, arr) {
      state.caseTabList = arr;
    },
    SAVE_PREV_INFO(state, data) {
      state.prevInfo = data;
    }
  },
  actions: {
    /**
     * @description: 教育化设备产品列表
     * @param {*}
     * @return {*}
     */

    listProductCategory({ commit }, { id }) {
      return new Promise((resolve, reject) => {
        listProductCategory(id).then((res) => {
          if (res.data.state == 1) {
            let list = res.data.data;
            resolve(list);
          } else {
            util.tips("res.data.code");
            reject(res.data.code);
          }
        });
      });
    },
    getBannerList() {
      return new Promise((resolve, reject) => {
        getBannerList().then((res) => {
          if (res.data.state == 1) {
            let list = res.data.data;
            resolve(list);
          } else {
            util.tips("res.data.code");
            reject(res.data.code);
          }
        });
      });
    },
    /**
     * @description: 获取分类列表：案例 培训中心的tab
     * @param {*}
     * @return {*}
     */

    getOfficialNewsCategory({ commit }, data) {
      return new Promise((resolve, reject) => {
        getOfficialNewsCategory(data.id).then((res) => {
          if (res.data.state == 1) {
            let list = res.data.data;
            if (data.type == "case") commit("SAVE_CASE_LIST", list);
            resolve(list);
          } else {
            util.tips("res.data.code");
            reject(res.data.code);
          }
        });
      });
    },
    /**
     * @description: 获取培训中心和案例中心的分页数据
     * @param {*}
     * @return {*}
     */

    getCaseOrTainByPage({ commit }, data) {
      return new Promise((resolve, reject) => {
        getCaseOrTainByPage(data.params, data.data).then((res) => {
          if (res.data.state == 1) {
            let list = res.data.data;
            resolve(list);
          } else {
            util.tips("res.data.code");
            reject(res.data.code);
          }
        });
      });
    },
    saveNews({ commit }, arr) {
      commit("SAVE_NEWS_LIST", arr);
    },
    savePrevInfo({ commit }, arr) {
      commit("SAVE_PREV_INFO", arr);
    },
    findCurrentTab({ commit, state }, data) {
      console.log(state.productNacList);
    },
    /**
     * @description: 获取列表
     * @param {*} commit
     * @param {*} data
     * @return {*}
     */

    getListProductContent({ commit }, { id }) {
      return new Promise((resolve, reject) => {
        listProductContent(id).then((res) => {
          if (res.data.state == 1) {
            let list = res.data.data;
            resolve(list);
          } else {
            util.tips("res.data.code");
            reject(res.data.code);
          }
        });
      });
    },
    //保存头部选中的tab
    saveTabInStore({ commit }, nav) {
      commit("SAVE_PRODUCT_CURRENT_TAB", nav);
      localStorage.setItem("nav", JSON.stringify(nav));
    },
    /**
     * @description: 请求产品中心的tab
     * @param {*} commit
     * @return {*}
     */

    getProductNavList({ commit }) {
      return new Promise((resolve, reject) => {
        findCategoryTree().then((res) => {
          if (res.data.state == 1) {
            let { device, other, equipment } = res.data.data;
            device.flag = "device";
            if (equipment) {
              equipment.flag = "equipment"
            }
            other.map((el) => {
              el.flag = "other";
            });
            let list = []
            if (equipment) {
              list = [device, ...other, equipment];
            } else {
              list = [device, ...other];
            }
            list.map((element) => {
              element.path = "/zh/productList";
              element.name =
                element.productCategoryName || element.productModuleName;
              element.border = true;
              element.isShow = false;
              element.children = element.childList;
              delete element.childList;
              element.children.map((el) => {
                el.path = "/zh/productInfo";
                el.name = el.productCategoryName || el.name;
              });
            });
            commit("SAVE_PRODUCT_NAV_LIST", list);
            resolve(list);
          } else {
            util.tips("res.data.code");
            reject(res.data.code);
          }
        });
      });
    },
    /**
     * @description: 请求列表数据-新闻、案例、配件
     * @param {*} commit
     * @param {*} pages
     * @param {*} data
     * @return {*}
     */

    getList({ commit }, { pages, data }) {
      return new Promise((resolve, reject) => {
        getNewsByPage(pages, data)
          .then((res) => {
            if (res.data.state == 1) {
              let list = res.data.data;
              resolve(list);
            } else {
              util.tips("res.data.code");
              reject(res.data.code);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  modules: {},
});